<template>
  <div>
    <v-img
      src="../../assets/background.svg"
      alt="Hive background"
      style="position: fixed"
      height="100%"
    />

    <v-dialog v-model="patchDialog" width="700" class="font">
      <PatchNotes :registerNote="registerNote" />
    </v-dialog>

    <Navigation :key="update" @openNotes="patchDialog = true" />

    <v-main class="font" style="z-index: 1">
      <router-view @updateProfileImage="updateProfile" />
    </v-main>

    <v-dialog v-model="alertDialog" persistent max-width="500px" class="font">
      <v-card color="#f2f2f2">
        <div class="backAlertTitle pa-3 d-flex align-center">
          <h2>{{ $t('Alertas pendentes') }}</h2>
          <v-spacer />
          <v-spacer />

          <v-btn icon @click="closeAlertDialog">
            <v-icon color="#fff">mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <strong>
            {{ $t('Você possui ') }}{{ alertQuantity }}
            {{ $t('alerta(s) sem visualização.') }}
          </strong>
        </v-card-text>
        <v-card-actions>
          <v-btn class="ma-1" color="grey" @click="closeAlertDialog">
            {{ $t('Fechar') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="ma-1" color="#B14949" @click="callAlertList">
            {{ $t('Visualizar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
@import '@/sass/variables.scss';
.font {
  font-family: 'Poppins', sans-serif;
}

.successAlert {
  z-index: 100;
  position: absolute;
  right: 2%;
  top: 10%;
  white-space: nowrap;
}

.backAlertTitle {
  background-color: #426483;
  color: #fff;
}

@media (max-width: 400px) {
  .successAlert {
    position: absolute;
    right: 7%;
    left: 7%;
  }
}
</style>

<script>
import PatchNotes from './PatchNotes'
import Navigation from './Navigation'
import ApiService from '../../services/ApiService'
import Component from '../../components/toast.vue'
import Utils from '../../Utils/FormatDate'

export default {
  name: 'Authenticated',

  async created() {
    this.getAlertsPending()

    this.$root.$on('OpenNotes', this.openNotes)

    const user = JSON.parse(localStorage.getItem('user'))
    const institution = JSON.parse(localStorage.getItem('institution'))
    if (
      institution.id == user.institutionId &&
      user.pendingCalleds &&
      user.pendingCalleds.length > 0
    ) {
      this.$toast(Component, {
        position: 'top-right',
        timeout: 10000,
        closeOnClick: false,
        pauseOnFocusLoss: true,
        pauseOnHover: true,
        draggable: false,
        draggablePercent: 0.6,
        showCloseButtonOnHover: true,
        closeButton: 'button',
        icon: true,
        rtl: false,
      })
    }
  },

  data: () => ({
    patchDialog: false,
    update: false,
    message: '',
    alertDialog: false,
    alertQuantity: 0,
    apiService: new ApiService(),
    registerNote: false,
  }),

  components: {
    Navigation,
    PatchNotes,
  },

  methods: {
    openNotes(toOpen) {
      this.registerNote = true
      this.patchDialog = toOpen
      setTimeout(() => {
        this.registerNote = false
      }, 500)
    },

    updateProfile() {
      this.update = !this.update
    },

    async getAlertsPending() {
      const institutionId = JSON.parse(localStorage.getItem('institution')).id
      const alerts = []

      await this.apiService
        .get(`alert/getPending/${institutionId}`, true, false)
        .then((response) => {
          response.content.map((alert) => {
            if (!this.compareDatetime(alert.alertDateTime)) {
              alerts.push(alert)
            }
            if (alerts.length) {
              if (this.$router.history.current.name != 'alert') {
                this.alertDialog = true
                this.alertQuantity = alerts.length
              }
            }
          })
        })
    },

    compareDatetime(datetime) {
      return Utils.compareDateTime(datetime)
    },

    callAlertList() {
      this.$router.push('/alert')
      this.closeAlertDialog()
    },

    closeAlertDialog() {
      this.alertDialog = false
    },
  },
}
</script>
